/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForDailyInventoryReport extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForDailyInventoryReport");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForDailyInventoryReport.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForDailyInventoryReport>): BackgroundJobPayloadForDailyInventoryReport {
        let obj = Object.assign(new BackgroundJobPayloadForDailyInventoryReport(), model);
        BackgroundJobPayloadForDailyInventoryReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForDailyInventoryReport>): BackgroundJobPayloadForDailyInventoryReport {
        if (!model) return null;
        return BackgroundJobPayloadForDailyInventoryReport.newInstance(<BackgroundJobPayloadForDailyInventoryReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForDailyInventoryReport) {
        if (!obj) return;

        models.BackgroundJobPayloadForDailyInventoryReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForDailyInventoryReport): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForDailyInventoryReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

}
